import React, { ReactNode } from 'react';
import { Grid2 as Grid, Box } from '@mui/material';

type ProfileCardProps = {
  actionButtons?: ReactNode;
  avatarSection?: ReactNode;
  primaryDetails?: ReactNode;
  fullSizeContent?: ReactNode;
  contentSections?: ReactNode[];
};

const ProfileCard: React.FC<ProfileCardProps> = ({
  actionButtons,
  avatarSection,
  primaryDetails,
  contentSections = [],
  fullSizeContent,
}) => {
  return (
    <Grid container spacing={1} sx={{ width: '100%' }}>
      {actionButtons && (
        <Grid container justifyContent="flex-end" sx={{ width: '100%' }}>
          <Grid>{actionButtons}</Grid>
        </Grid>
      )}

      {fullSizeContent ? (
        <Box sx={{ padding: '0 16px 16px' }}>{fullSizeContent}</Box>
      ) : (
        <>
          <Grid
            container
            spacing={1}
            sx={{
              flex: '1 1 auto',
              width: '100%',
              paddingBottom: '16px',
              '&:not(:last-child)': { borderBottom: '1px solid', borderBottomColor: 'border.medium' },
            }}
          >
            {avatarSection && <Grid size={3}>{avatarSection}</Grid>}

            {primaryDetails && <Grid size={9}>{primaryDetails}</Grid>}
          </Grid>

          <Grid
            container
            spacing={1}
            sx={{
              flex: '1 1 auto',
              width: '100%',
              paddingBottom: '16px',
              '&:not(:last-child)': { borderBottom: '1px solid', borderBottomColor: 'border.medium' },
            }}
          >
            {contentSections.map((section, index) => {
              const key = React.isValidElement(section) && section.key != null ? section.key : index;

              return (
                <Grid
                  size={12}
                  key={key}
                  sx={{
                    '&:not(:last-child)': {
                      paddingBottom: '8px',
                      borderBottom: '1px solid',
                      borderBottomColor: 'border.medium',
                    },
                  }}
                >
                  {section}
                </Grid>
              );
            })}
          </Grid>
        </>
      )}
    </Grid>
  );
};

export default ProfileCard;
